import { LockIcon, CommunityIcon, GlobeIcon, AddUserIcon } from '@/assets/icons';
import type { IconComponent } from '@/types/types';
import { PRIVACY_TYPES, type PrivacyType } from '../model';

/**
 * Дефолтное значение приватности для новых вишлистов
 */
export const DEFAULT_PRIVACY: PrivacyType = 'public';

export interface PrivacyOption {
  id: PrivacyType;
  labelKey: string;
  descriptionKey: string;
  icon: IconComponent;
}

/**
 * Опции приватности вишлиста
 * labelKey и descriptionKey используются для i18n (features.createWishlist.privacy.{id}.label/description)
 * Порядок элементов соответствует PRIVACY_TYPES (SSOT)
 */
export const PRIVACY_OPTIONS: PrivacyOption[] = PRIVACY_TYPES.map((id) => {
  // Маппинг иконок и i18n ключей для каждого типа приватности
  const config: Record<PrivacyType, { icon: IconComponent; labelKey: string; descriptionKey: string }> = {
    public: {
      icon: GlobeIcon,
      labelKey: 'wishlist:createWishlist.privacy.public.label',
      descriptionKey: 'wishlist:createWishlist.privacy.public.description',
    },
    friends: {
      icon: CommunityIcon,
      labelKey: 'wishlist:createWishlist.privacy.friends.label',
      descriptionKey: 'wishlist:createWishlist.privacy.friends.description',
    },
    selected: {
      icon: AddUserIcon,
      labelKey: 'wishlist:createWishlist.privacy.selected.label',
      descriptionKey: 'wishlist:createWishlist.privacy.selected.description',
    },
    private: {
      icon: LockIcon,
      labelKey: 'wishlist:createWishlist.privacy.private.label',
      descriptionKey: 'wishlist:createWishlist.privacy.private.description',
    },
  };

  return {
    id,
    ...config[id],
  };
});